import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "Card",
  style: {"background-color":"white","border-radius":"7px"}
}
const _hoisted_2 = { class: "row p-3" }
const _hoisted_3 = { class: "col-md-4 col-12 rounded-3 text-center my-auto" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "col-md-8 col-12 text-white text-center mt-3" }
const _hoisted_6 = {
  style: {"color":"#3f4254 !important"},
  class: "text-md-start"
}
const _hoisted_7 = {
  class: "text-md-start",
  style: {"text-transform":"capitalize","color":"#b5b5c3 !important","font-weight":"500 !important","margin-bottom":"1rem !important","font-size":"13px !important"}
}
const _hoisted_8 = {
  style: {"margin":"0","height":"62px","color":"#5e6278 !important","font-weight":"600"},
  class: "overflow-hidden text-md-start text-dark mx-auto resp-width"
}
const _hoisted_9 = { class: "row mt-md-0 my-3" }
const _hoisted_10 = { class: "col-md-4 text-primary text-md-start my-md-0 my-3" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "col-md-4 text-primary text-md-start my-md-0 my-3" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "col-md-4 text-primary text-md-start ps-md-5 my-md-0 my-3" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 0,
  href: "javacript:void(0)",
  class: "linkse2"
}
const _hoisted_17 = ["data-kt-indicator"]
const _hoisted_18 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_19 = { class: "indicator-progress" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_21 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle ms-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              class: "my-2 resp-img rounded",
              src: `${_ctx.profilePicture ?? _ctx.avatar}`,
              style: {"width":"140px","height":"138px","object-fit":"cover"}
            }, null, 8, _hoisted_4)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.name), 1),
          _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.truncateText(_ctx.jobTitle, 27)), 1),
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.introduction), 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("a", {
                class: "linkse",
                target: "_blank",
                href: _ctx.linkedInProfile
              }, "LinkedIn", 8, _hoisted_11)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("a", {
                class: "linkse",
                target: "_blank",
                href: `/expert/${_ctx.expertId}`
              }, "View Profile", 8, _hoisted_13)
            ]),
            _createElementVNode("div", _hoisted_14, [
              (!_ctx.fromConnectedExperts)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (
                    _ctx.isConnected &&
                    _ctx.expertRequisiteConnectionStatus[_ctx.expertId] !== ''
                  )
                      ? (_openBlock(), _createElementBlock("a", _hoisted_16, _toDisplayString(_ctx.expertRequisiteConnectionStatus[_ctx.expertId] == 0
                      ? "Pending"
                      : _ctx.expertRequisiteConnectionStatus[_ctx.expertId] == 1
                      ? "Connected"
                      : _ctx.expertRequisiteConnectionStatus[_ctx.expertId] == 2
                      ? "Rejected"
                      : ""), 1))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          "data-kt-indicator": _ctx.loading ? 'on' : null,
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.attachExpert && _ctx.attachExpert(...args))),
                          href: "javascript:void(0)",
                          class: "linkse2"
                        }, [
                          (!_ctx.loading)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, " Connect "))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_19, [
                            _hoisted_20,
                            (_ctx.loading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_21))
                              : _createCommentVNode("", true)
                          ])
                        ], 8, _hoisted_17))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}